// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_UnidadesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /rede/unidades — todas as unidades da rede com a situação (Full). */
import type { Rede_UnidadeRow } from './Rede_UnidadeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_UnidadesResponseDados {
unidades: Rede_UnidadeRow[]
total: number
}

export type Rede_UnidadesResponse = ApiResponse<Rede_UnidadesResponseDados>;

registerResponseContract('Rede_UnidadesResponse', {
  unidades: {
    type: 'array',
    required: true,
    items: {
      franquia_id:         { type: 'number',  required: false },
      externa_id:          { type: 'number',  required: false },
      no_sistema:          { type: 'boolean', required: false },
      numero_planilha:     { type: 'number',  required: false },
      nome:                { type: 'string',  required: false },
      situacao:            { type: 'string',  required: true },
      situacao_desde:      { type: 'string',  required: false },
      situacao_registrada: { type: 'boolean', required: false },
      pais:                { type: 'string',  required: false },
      uf:                  { type: 'string',  required: false },
      cidade:              { type: 'string',  required: false },
      inaugurado_em:       { type: 'string',  required: false },
      pasta_drive_url:     { type: 'string',  required: false },
      contrato_codigo:     { type: 'string',  required: false },
      vigencia_ate:        { type: 'string',  required: false },
      alerta_contrato:     { type: 'string',  required: false },
    },
  },
  total:    { type: 'number',  required: true },
})
